import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const ROLE_LABELS = { admin: "Admin", yonetici: "Yönetici", muhasebeci: "Muhasebeci", muhasebe_stj: "Muhasebe Stj." };

export function DashboardVisibilityControl({ onChanged, kind = "dashboard", title = "Tahsilat & vekalet toplamları", label = "Özet Görünürlüğü", choices }) {
  const [roles, setRoles] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/tahsilat-settings/${kind}`).then((r) => setRoles(r.data.roles)).catch(() => setRoles([]));
  }, [kind]);

  const toggle = async (role) => {
    const next = roles.includes(role) ? roles.filter((x) => x !== role) : [...roles, role];
    setSaving(true);
    try {
      const r = await api.put(`/tahsilat-settings/${kind}`, { roles: next });
      setRoles(r.data.roles);
      toast.success(`${label} güncellendi`);
      onChanged?.();
    } catch {
      toast.error("Güncellenemedi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`tahsilat-${kind}-visibility-btn`} title="Özet kartlarını hangi roller görsün?"
          className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-600 hover:text-slate-900 bg-white border border-slate-200 hover:border-slate-300 px-2.5 py-1 rounded-full transition-colors">
          <Eye size={12} /> {label}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 p-3" data-testid={`tahsilat-${kind}-visibility-panel`}>
        <div className="text-xs font-bold text-slate-900 mb-1">{title}</div>
        <div className="text-[11px] text-slate-500 mb-2">İşaretli roller bu özeti görür.</div>
        {roles === null ? (
          <div className="text-xs text-slate-400">Yükleniyor...</div>
        ) : (
          Object.entries(ROLE_LABELS).filter(([k]) => !choices || choices.includes(k)).map(([k, l]) => (
            <label key={k} className="flex items-center gap-2 py-1 text-sm text-slate-800 cursor-pointer">
              <input type="checkbox" checked={roles.includes(k)} disabled={saving} onChange={() => toggle(k)}
                data-testid={`tahsilat-${kind}-role-${k}`} />
              {l}
            </label>
          ))
        )}
      </PopoverContent>
    </Popover>
  );
}
